// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__u3B4a","label":"Section_label__1XzVP","contentWrap":"Section_contentWrap__3rOKa","footer":"Section_footer__CBRQ3","footerInner":"Section_footerInner__2CDXm"};